import { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../axios";
import "dropify/dist/css/dropify.min.css";
import "dropify/dist/js/dropify.min.js";
import $ from "jquery";

const AddEvent = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditing = !!id;

  const fileInputRef = useRef(null);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const [formData, setFormData] = useState({
    title: "",
    date: "",
    description: "",
    location: "",
  });

  // Load existing event data on edit
  useEffect(() => {
    if (isEditing) {
      axios
        .get(`/events/${id}`)
        .then((res) => {
          const event = res.data;
          setFormData({
            title: event.title || "",
            date: event.date || "",
            description: event.description || "",
            location: event.location || "",
          });
          setImagePreview(event.image_url || "");
        })
        .catch((err) => {
          console.error("Error fetching event:", err);
          alert("Could not load event data");
        });
    }
  }, [id, isEditing]);

  // Dropify for edit with preview
  useEffect(() => {
    if (isEditing && imagePreview) {
      const $input = $(fileInputRef.current);

      const drEvent = $input.data("dropify");
      if (drEvent) drEvent.destroy();

      $input.attr("data-default-file", imagePreview);

      setTimeout(() => {
        $input.dropify();
      }, 50);
    }
  }, [imagePreview, isEditing]);

  // Dropify for new (non-edit) mode
  useEffect(() => {
    if (!isEditing) {
      const $input = $(fileInputRef.current);

      const drEvent = $input.data("dropify");
      if (drEvent) drEvent.destroy();

      $input.removeAttr("data-default-file");

      setTimeout(() => {
        $input.dropify();
      }, 50);
    }
  }, [isEditing]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("title", formData.title);
    data.append("date", formData.date);
    data.append("location", formData.location);
    data.append("description", formData.description || "");

    if (imageFile) {
      data.append("image", imageFile);
    }

    const request = isEditing
      ? axios.post(`/events/${id}?_method=PUT`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        })
      : axios.post("/events", data, {
          headers: { "Content-Type": "multipart/form-data" },
        });

    request
      .then(() => {
        alert(isEditing ? "Event updated!" : "Event added!");
        navigate("/admin/eventList");
      })
      .catch((err) => {
        console.error("Error saving event:", err.response?.data || err);
        alert("Operation failed");
      });
  };

  return (
    <div className="main-content">
      <button
        className="btn text-black mb-3 border-0"
        onClick={() => navigate("/admin/eventList")}>
        <h5>
          ← <span className="ms-2">Back to Event List</span>
        </h5>
      </button>

      <form onSubmit={handleSubmit}>
        <div className="row gap-lg-5">
          <div className="mb-3 col-5">
            <label className="form-label">
              Event Name<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="title"
              className="form-control"
              placeholder="Enter event name"
              value={formData.title}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3 col-5">
            <label className="form-label">
              Event Date<span className="text-danger">*</span>
            </label>
            <input
              type="date"
              name="date"
              className="form-control"
              value={formData.date}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="mb-3 col-5">
          <label className="form-label">Description</label>
          <textarea
            name="description"
            className="form-control"
            rows="3"
            placeholder="Enter Description"
            value={formData.description}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3 col-5">
          <label className="form-label">
            Location<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            name="location"
            className="form-control"
            placeholder="Enter location"
            value={formData.location}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3 col-5">
          <label className="form-label">
            Event Image <span className="text-danger">*</span>
          </label>
          <input
            type="file"
            ref={fileInputRef}
            className="form-control dropify"
            accept=".jpg,.jpeg,.png"
            onChange={handleImageChange}
            {...(!isEditing && { required: true })}
          />
        </div>

        <div className="text-end">
          <button
            type="submit"
            className="btn gold-add-btn py-2 px-4 w-auto rounded-0 text-white">
            {isEditing ? "Update" : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddEvent;
